import React, { useState, useEffect } from "react";
// import { videoCamsArray } from "../../assets/globalArrays/videoCamsArray";

import { videoCamsArray } from "../../../assets/globalArrays/videoCamsArray";

export default function VideoCams({
  packageShow,
  packageDocReady,
  iconClass,
  containerClass,
  heading,
}) {
  const [videoCams, setVideoCams] = useState();
  const [displaySection, setDisplaySection] = useState(false);

  useEffect(() => {
    if (packageDocReady) {
      setVideoCams(packageShow.videoCams);
    }
  }, [packageDocReady, packageShow]);

  const display = () => {
    setDisplaySection(!displaySection);
    console.log("Click Video Cameras", displaySection);
  };

  return (
    <>
      <div className="cursor-pointer">
        <p className={heading} onClick={display}>
          Video Cameras
        </p>
        {displaySection && (
          <div className="grid grid-cols-2 md:grid-cols-4 md:gap-4">
            {videoCams &&
              videoCams.map((item) => {
                const i = videoCamsArray().findIndex((e) => e.value === item);
                // const i = 0;
                // console.log("Item: ", item);
                // console.log("i: ", i);
                const icon = videoCamsArray(iconClass)[i].icon;
                const title = videoCamsArray()[i].title;
                return (
                  <div key={item} className={containerClass}>
                    <span>{icon}</span>
                    <span className="capitalize ml-2 text-xs">{title}</span>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
}
